<template>
  <div class="call_area" ref="tile">
    <div class="waiting_for_others">
      <p>Waiting for others to arrive.</p>

      <div class="room_link">
        <p class="user_room_name">{{ shareLink }}</p>

        <div class="df align_center copy-and-share-container">
          <clickToCopy :text="shareLink"></clickToCopy>

          <button
            @click="show_drop = !show_drop"
            v-click-outside="hide"
            class="room_extra hover_op"
          ></button>
        </div>
      </div>

      <p v-if="isPrivate">The room is locked.</p>
    </div>

    <div class="share_link_drop" :class="{ active: show_drop }">
      <p class="titled">Share</p>

      <div class="input_wrap">
        <p>Email address</p>

        <input
          type="email"
          placeholder="e.g., edithanderson@gmail.com"
          class="email-input"
          v-model="send_invite_email"
          v-on:keyup.enter="sendEmailInvite"
        />
      </div>

      <button
        class="color_btn hover_op"
        :class="{ disabled: send_invite_email === '' }"
        @click.enter="sendEmailInvite"
      >
        Send
      </button>
    </div>
  </div>
</template>

<script>
import clickToCopy from "@/components/clickToCopy.vue";
import axios from "axios";
import ClickOutside from "vue-click-outside";

export default {
  name: "waitingForOthers",

  data() {
    return {
      show_drop: false,
      send_invite_email: "",
    };
  },

  components: { clickToCopy },

  computed: {
    localParticipant() {
      return this.$store.getters.localParticipant;
    },
    roomData() {
      return this.$store.state.meeting.meeting;
    },

    isPrivate() {
      return !this.roomData.isPublic;
    },

    shareLink() {
      const { protocol, host } = window.location;
      return `${protocol}//${host}/room/${this.nickname}`;
    },

    nickname() {
      return this.$route.params.nickname;
    },
  },

  methods: {
    hide() {
      this.show_drop = false;
    },

    async sendEmailInvite() {
      try {
        const { dailyRoomName: meetingId, token, id: roomId } = this.roomData;
        await this.$store.dispatch("sendMeetingInvite", this.send_invite_email);

        this.$store.commit("showNotification", "succes");
        this.$store.commit(
          "notificationContent",
          "Invite successful send to user email"
        );
        this.show_drop = false;
        this.send_invite_email = "";
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },
  },

  mounted() {
    this.popupItem = this.$el;
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss">

.call_area {
  min-height: 208px;
}

.waiting_for_others {
  position: absolute;
  background: #000;
  border-radius: 16px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 32px;
  padding-right: 32px;

  @media all and (max-width: 767px) {
    position: relative;
    padding: 32px 16px;
    height: 100%;
  }

  p {
    margin-bottom: 32px;
    color: #fff;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;

    @media all and (max-width: 767px) {
      margin-bottom: 16px;
    }
  }

  .room_link {
    width: 100%;
    .user_room_name {
      padding: 0 8px 0px 0px !important;
      white-space: nowrap;
    }
    & + p {
      margin-top: 32px;
      margin-bottom: 0;
      @media all and (max-width: 767px) {
        margin-top: 16px;
      }
    }

    .room_extra {
      background: url("../assets/img/share_room_link.svg") no-repeat
        center/contain;
    }
  }
}

.share_link_drop {
  top: calc(50% + 27px);
  right: 50px;
  width: 422px;
  opacity: 0;
  display: none;
  pointer-events: none;
  transition: opacity 180ms;
  z-index: 2;
  position: absolute;
  padding: 32px !important;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0 0 32px rgb(0 0 0 / 16%);

  @media all and (max-width: 815px) {
    padding: 16px;
  }

  &.active {
    display: block;
    opacity: 1;
    transition: opacity 180ms;
    pointer-events: all;
  }

  @media all and (max-width: 767px) {
    top: -35%;
    width: auto;
    left: 0;
    right: 0;

    & > * {
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  p.titled {
    margin-bottom: 32px;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;

    @media all and (max-width: 767px) {
      margin-bottom: 16px;
    }
  }
  .input_wrap input {
    padding-top: 0 !important;
  }
  .input_wrap p {
    margin-bottom: 8px;
    opacity: 0.32;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    padding: 0 !important;
  }
}

.color_btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.email-input {
  color: rgba(0, 0, 0, 1);
  font-family: "NunitoSans-Bold";
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  letter-spacing: 0px;
  text-align: left;
  line-height: 24px;
}

.copy-and-share-container {
  flex: 0 0 64px;
}
</style>
